var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'asc-container--container',
    _vm.flat ? 'asc-container--container--flat' : null,
    _vm.nested ? 'asc-container--container--nested' : null,
    _vm.floating ? 'asc-container--container--floating' : null ]},[_vm._t("tabs"),_c('div',{staticClass:"asc-container--headerWrapper"},[_vm._t("navLink"),_vm._t("header"),_vm._t("subheader")],2),_c('div',{staticClass:"asc-container--contentWrapper"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }